function resolveCSSVariable(inputString: string, rootElement: HTMLElement): string {
    return getComputedStyle(rootElement).getPropertyValue(inputString).trim();
}

export { resolveCSSVariable };
